import { getImagePath } from "../../getImagePath";

const SLIDE_DATA = [
    {
        title: "步驟一：拖曳選擇統計主題和圖表類型",
//         text: `畫面左側為可供查找的統計主題和子項目，您可以從左側選擇您想要製圖的統計項目，
// 將項目拖曳到右側「1. 請選擇要製圖的項目」欄位。\n
// 如果您想要進一步查看兩不同項目間的關係，您可以選擇另一個統計項目當作資料分類依據，
// 並將項目拖曳到右側「2. 可選取新的項目將上述項目分類」欄位. 請選擇要製圖的項目」欄位。
// 最後再選擇要製作的圖表類型，就能成功產出圖表囉！`,
        video: getImagePath("/tutorial-page/step-1.mp4"),
    },
    {
        title: "步驟二：獲得互動式圖表輕鬆查看各縣市數據",
        text: `生成圖表後，您可以選擇查看不同震度區域的調查結果，以及選擇你想查看的統計值。`,
        video: getImagePath("/tutorial-page/step-2.mp4"),
    },
    {
        title: "步驟三：下載圖片和數據，立刻自由應用",
        text: `除了在網站上查看數據，您也可以下載圖表或原始數據自由運用`,
        video: getImagePath("/tutorial-page/step-3.mp4"),
    }

]

export default SLIDE_DATA;